// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","MorePosts__posts":"oy_a bhe_ra bhe_qv bhe_xp"};